import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface LastImportDetailsResponse {
  importId: number;
  importBy: string;
  importOn: string;
  uploadedFileName: string;
  importByUserId: number;
  importExceptionFile: {
    fileName: string;
    successCount: number;
    failedCount: number;
  };
}

const useLastImportDetailsApi = (companyId: string) => {
  const call = useCallback<() => Promise<LastImportDetailsResponse>>(
    () =>
      axiosInstance<LastImportDetailsResponse>(api.lastImport(companyId))
        .then((res) => res.data)
        .catch((err) => {
          throw new Error(err.message);
        }),
    [companyId]
  );
  const { value, execute } = useAsync(call, true);

  return { value, execute };
};
export default useLastImportDetailsApi;
